export const AUTH_METHODS = {
  usernamePassword: 'usernamePassword',
  usernameOtp: 'usernameOtp',
};

export const FIRST_APP_OPEN = '@firstAppOpen';
export const ACCESS_TOKEN = '@accessToken';
export const REFRESH_TOKEN = '@refreshToken';

interface CreateQueryProps {
  filter: any;
  customFields?: {
    customKey: string;
    newValue: string;
    valueType: 'text' | 'array';
    secondaryValue?: string;
  }[];
}

export const createQuery = ({ filter, customFields }: CreateQueryProps) => {
  const customFieldsObj = Object.fromEntries(customFields?.map((item) => [item.customKey, item]) || []);

  return Object.entries(filter)
    .filter(([key, value]) => value)
    .map(([key, value]) => {
      const customObj = customFieldsObj[key];

      if (customObj?.newValue && value) {
        const { newValue, valueType, secondaryValue } = customObj;

        if (valueType === 'array' && Array.isArray(value)) {
          return value.map((val) => `${newValue}=${val}`).join('&');
        } else {
          const param = `${newValue}=${value}`;

          if (secondaryValue) {
            return `${param}&${secondaryValue}=${value}`;
          } else {
            return param;
          }
        }
      } else {
        return `${key}=${value}`;
      }
    })
    .join('&');
};

export const randomKeyObject = (obj: any) => {
  // Get all the keys and values as an array
  const entries = Object.entries(obj);

  // Combine keys and values into a single string
  const str = entries.reduce((acc, [key, value]) => acc + key + value, '');

  // Generate a random string based on the combined string
  const randomStr = Math.random().toString(36).substring(2) + str;

  return randomStr;
};

export const removeEmpty = (obj: any) => {
  return Object.entries(obj)
    .filter(([_, v]) => v)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
};
